<template>
  <div @paste="handleLocalPaste">
    <!-- File Upload Field -->
    <v-file-input
      ref="fileInput"
      clearable
      multiple
      density="comfortable"
      label="Dokumente (PDF, JPG, JPEG, PNG und DXF)"
      variant="outlined"
      accept=".pdf,.jpg,.jpeg,.png,.dxf"
      @change="handleFileUpload"
    ></v-file-input>

    <!-- Informational Message -->
    <div class="info-message">
      <p>
        Tipp: Sie können auf das Feld klicken und <kbd>CTRL</kbd> +
        <kbd>V</kbd> verwenden (Optionales Feld).
      </p>
    </div>

    <!-- Display the list of files -->
    <div class="file-list">
      <div v-for="(file, index) in files" :key="index" class="file-item">
        <div class="preview-container">
          <!-- Preview for images -->
          <img
            v-if="isImageFile(file)"
            :src="getImagePreview(file)"
            alt="Preview"
            class="image-preview"
          />
          <!-- Icon for non-image files -->
          <v-icon v-else>{{ getFileIcon(file) }}</v-icon>
        </div>
        <div class="file-name">{{ file.name }}</div>
        <v-btn icon color="primary" size="small" @click="removeFile(index)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      files: [],
    }
  },
  methods: {
    handleFileUpload(event) {
      const newFiles = Array.from(event.target.files || [])
      this.addFiles(newFiles)
      this.$refs.fileInput.reset()
    },

    handleLocalPaste(event) {
      const pasteTarget = event.target
      const componentContainer = this.$el

      if (componentContainer.contains(pasteTarget)) {
        const clipboardFiles = event.clipboardData?.files
        if (clipboardFiles && clipboardFiles.length > 0) {
          event.preventDefault()
          this.addFiles(Array.from(clipboardFiles))
        }
      }
    },

    addFiles(newFiles) {
      const allowedTypes = [
        'application/pdf',
        'image/jpeg',
        'image/png',
        'image/dxf',
      ]
      const filteredFiles = newFiles.filter(
        (file) => allowedTypes.includes(file.type) && !this.isDuplicate(file),
      )
      this.files = [...this.files, ...filteredFiles]
      this.$emit('updateFiles', this.files)
    },

    isImageFile(file) {
      return file.type.startsWith('image/')
    },

    isDuplicate(file) {
      return this.files.some(
        (existingFile) =>
          existingFile.name === file.name && existingFile.size === file.size,
      )
    },

    getFileIcon(file) {
      if (!file.type) return 'mdi-file'
      if (file.type.includes('pdf')) return 'mdi-file-pdf'
      return 'mdi-file'
    },

    getImagePreview(file) {
      return URL.createObjectURL(file)
    },

    removeFile(index) {
      const removedFile = this.files[index]
      this.files.splice(index, 1)
      this.$emit('updateFiles', this.files)
      URL.revokeObjectURL(removedFile)
      console.log(this.files)
    },
  },
}
</script>

<style scoped>
.file-list {
  margin-top: 10px;
}

.file-item {
  display: flex;
  align-items: center;
  padding: 8px;
  border-bottom: 1px solid #eee;
}

.preview-container {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}

.image-preview {
  max-width: 100%;
  max-height: 100%;
}

.file-name {
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.info-message {
  margin-top: 8px;
  font-size: 0.875rem;
  color: #666;
}

.info-message kbd {
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  padding: 2px 4px;
  border-radius: 3px;
  font-family: monospace;
}
</style>
